module.exports = __webpack_public_path__ + "media/images/bg/headers/bamboo-forest-right-112ba7f1eedc96fdec5a26b97cec34e8.png";